/**
 * @flow
 * @relayHash 0c5f25dd9abbdea34f0db51b0f63e967
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PayWithPaypalInput = {|
  nonce: string,
  orderId: string,
|};
export type PayWithPaypalMutationVariables = {|
  input: PayWithPaypalInput
|};
export type PayWithPaypalMutationResponse = {|
  +payWithPaypal: ?{|
    +order: ?{|
      +id: string,
      +orderid: ?string,
      +state: ?string,
    |}
  |}
|};
export type PayWithPaypalMutation = {|
  variables: PayWithPaypalMutationVariables,
  response: PayWithPaypalMutationResponse,
|};
*/


/*
mutation PayWithPaypalMutation(
  $input: PayWithPaypalInput!
) {
  payWithPaypal(input: $input) {
    order {
      id
      orderid
      state
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PayWithPaypalInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "payWithPaypal",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PayWithPaypalPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "order",
        "storageKey": null,
        "args": null,
        "concreteType": "Order",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "orderid",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "state",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PayWithPaypalMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "PayWithPaypalMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "PayWithPaypalMutation",
    "id": null,
    "text": "mutation PayWithPaypalMutation(\n  $input: PayWithPaypalInput!\n) {\n  payWithPaypal(input: $input) {\n    order {\n      id\n      orderid\n      state\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8a58e84537c6894feb02e2afa2f07c92';

module.exports = node;
